import { appAPI } from '.';
import { notify } from '../../clients/ApiService';
import { LatestReleaseDismissData } from '../../constants';
import { ApiTags } from './appApi';

const latestReleaseApi = appAPI.injectEndpoints({
  endpoints: build => ({
    getDismissedLatestRelease: build.query<LatestReleaseDismissData, null>({
      query: () => ({
        path: `/latest-releases/`,
        method: 'get',
        options: {},
      }),
      providesTags: [ApiTags.latest_releases],
    }),
    updateLatestReleaseDismissal: build.mutation<
      LatestReleaseDismissData,
      unknown
    >({
      query: body => ({
        path: `/latest-releases/dismiss`,
        method: 'post',
        options: {
          body,
        },
      }),
      async onQueryStarted({ structFields }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          latestReleaseApi.util.updateQueryData(
            'getDismissedLatestRelease',
            undefined,
            draft => {
              // eslint-disable-next-line no-param-reassign
              draft.structFields.latest_release_dismissed =
                structFields.latest_release_dismissed;
            },
          ),
        );
        try {
          await queryFulfilled;
        } catch (error) {
          patchResult.undo();
          notify({
            status: 'error',
            errorMessage: 'This latest release card could not be deleted.',
            error,
            dispatch,
          });
        }
      },
    }),
  }),
});

export const {
  useUpdateLatestReleaseDismissalMutation,
  useGetDismissedLatestReleaseQuery,
} = latestReleaseApi;
